/**
 * Edit Network Corridor Form Composer
 *
 * Reuses AddNetworkCorridorComposer with initialValues for edit mode.
 * Submit label comes from the local edit form.yml configuration.
 */

import { AddNetworkCorridorComposer, type AddNetworkCorridorComposerProps } from '../addNetworkCorridor/composer'
import type { AddNetworkCorridorFormData } from '../addNetworkCorridor/schema'
import { FORM_CONFIG } from './schema'

export type EditNetworkCorridorComposerProps = Omit<AddNetworkCorridorComposerProps, 'initialValues'> & {
  initialValues: AddNetworkCorridorFormData
  submitLabel?: string
}

export function EditNetworkCorridorComposer(props: EditNetworkCorridorComposerProps) {
  return (
    <AddNetworkCorridorComposer
      {...props}
      submitLabel={props.submitLabel ?? FORM_CONFIG.submitButton?.label ?? 'Save Corridor'}
    />
  )
}
